

import Module, { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import Utility from "../../../../utility/utility";
import BiPaiTableView from "./bipai_table_view";
import { Card, CardColor, CardNameIndex } from "./bipai_card_common";
import ModelData from "../../../public/model_data";
import PromiseUtility from "../../../../utility/promiseUtility";
import BiPaiTableSound from "./bipai_table_sound";

const const_wan_codes = [10, 11, 12, 13, 14, 15, 16, 17, 18]
const const_tong_codes = [19, 20, 21, 22, 23, 24, 25, 26, 27]
const const_tiao_codes = [1, 2, 3, 4, 5, 6, 7, 8, 9]

const const_recycle_duration: number = 1
const const_recycle_interval: number = 0.1
const const_recycle_seat_interval: number = 0.133
const const_fapai_duration: number = 0.6
const const_fapai_single_interval: number = 0.1
const const_fapai_seat_interval: number = 0.1

const const_mopai_duration: number = 0.63
const const_discard_duraton: number = 1.3
const const_gold_fly_duration: number = 0.5

const { ccclass } = cc._decorator;

@ccclass
@moduleInit("BiPaiTestModule")
export default class BiPaiTestModule extends Module<BiPaiTableView, null>  {

    m_lastRefreshTime = 0    
    
    protected m_tableSound: BiPaiTableSound = null

    constructor() {
        super();
        this.viewType = BiPaiTableView
        this.modelType = null
        this.windowPrefabResPath = 'package/bipai/bipai_table'
        this.m_tableSound = new BiPaiTableSound()
    }

    onShow(arg){
        super.onShow(arg)
        this.view.buttonMask.node.on('click', this.on_click, this)
    }

    protected on_click(btn: cc.Button){
        cc.log('on_click-----------', btn.name)
        if(btn.node == this.view.buttonMask.node){
            this.testShowHandCards()            
        }

    }

    protected getTargetCodes(codeList: number[], includeCodes: number[]){
        let list: number[] = []
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            for (let i = 0; i < includeCodes.length; i++) {
                const includeCode = includeCodes[i];
                if(code == includeCode){
                    list.push(code)
                    break
                }
            }
        }
        return list
    }

    protected isWan(code: number){
        return code >= 10 && code <= 18
    }

    protected isTong(code: number){
        return code >= 19 && code <= 27
    }

    protected isTiao(code: number){
        return code >= 1 && code <= 9
    }

    protected test_dispatch(localPos: number){
        let self = this
        let code = 1
        let codeList = [
            1, 2, 3, 4
        ]

    }

    @bindButtonClickEvent('openBtn')
    protected on_click_open_card_btn(node: cc.Node){
        this.view.playBtnClickAnim(node)     
    }

    protected getComingCode(codeList: number[]): number{
        if(codeList.length % 3 == 2){
            return codeList[codeList.length - 1]
        }
        return -1
    }

    protected testHandCards(){
        let self = this
        let count = 5
        let codeList = [
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_K), 
        ]
        let tmpList = [
            0, 0, 0, 0, Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6), 
        ]
        for (let index = 0; index < count; index++) {
            if(index == 0){
                self.view.mySeatCards.showPokers(true, codeList)
            }else{
                self.view.showSeatHandCards(index, true, tmpList)
            }            
        }
    }

    protected testFaPai(){
        let self = this
        let maxCount = 5
        let count = 2
        let duration = const_fapai_duration
        let interval = count * const_fapai_single_interval * (maxCount / count)
        let delay = const_fapai_seat_interval * (maxCount / count)
        let codeList = [
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_K), 
        ]
        let tmpList = [
            0, 0, 0, 0, Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6), 
        ]
        let do_funs = []
        for (let index = 0; index < count; index++) {            
            let tmpIndex = index
            let tmpFun = function(cb){
                if(tmpIndex == 0){                
                    self.view.mySeatCards.playFaPaiAnim(codeList, 10, duration, interval, (tmpIndex) * delay, cb, null, cc.easeCubicActionOut())
                }else{
                    self.view.playSeatFaPaiAnim(tmpIndex, tmpList, duration, interval, (tmpIndex) * delay, cb)
                } 
            }   
            do_funs.push(tmpFun)                    
        }

        PromiseUtility.all(do_funs).then(function(){
        })
    }

    protected testMoPai(){
        let self = this
        let codeList = [                        
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_A),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),                        
        ]
        let code = Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_A)
        self.view.mySeatCards.playMoPaiAnim(code, codeList, 0, const_mopai_duration, 0, null, null, null, cc.easeCubicActionOut())        
        self.view.playSeatMoPaiAnim(1, code, codeList, const_mopai_duration)
    }

    protected testPlayDiscards(cardColor?){
        let self = this
        cardColor = cardColor || Utility.randomToInt(CardColor.color_black_heart, CardColor.color_square)
        let discards = [
            Card.colorIndexToCode(cardColor, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
        ]
        for (let index = 0; index < 5; index++) {
            let num = Utility.random(0, 1)
            if(num > -1){
                self.view.playDispatchCard(index, discards, const_discard_duraton, null)                        
            }
            
        }
        // self.view.playDispatchCard(3, discards, const_discard_duraton, null)
        // self.view.playSeatGenPaiAnim(3, 1, const_discard_duraton * 0.16)
        // self.view.playSeatBombAnim(1, const_discard_duraton * 0.25, function(){
            
        // })
        // self.view.playGoldFlyAnim(1, 3, const_gold_fly_duration, null, 7, 0.05, const_discard_duraton * 0.25 + 0.5 * 0.6)
        // self.view.showSeatGoldAnim(3, true, const_discard_duraton * 0.25 + 0.5 * 0.6 + const_gold_fly_duration * 1.1)
        
    }

    protected testPlayDiscardAndRecycle(name?){
        let self = this
        let discards1 = [
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),
            // Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
        ]
        let cleanDelay = const_discard_duraton * 0.29
        let list = []
        let count = 5
        for (let index = 0; index < count; index++) {
            let tmpIndex = index
            
            let tmpFun = function(cb){
                self.view.playRecycleDispatchCards(index, tmpIndex != 0, const_recycle_duration, const_recycle_interval, cleanDelay + const_recycle_seat_interval * index, cb)  
            }   
            list.push(tmpFun)                 
            if(index == 0){
                list.push(function(cb){
                    self.view.playDispatchCard(index, discards1, const_discard_duraton, null, function(){
                        cb()
                    })
                })
                
            }                           
        }        
        PromiseUtility.all(list).then(function(){
            cc.warn('11111111111111111111111')
        })
    }

    protected testPlayRecycelAll(){
        let self = this
        let count = 5
        let list = []
        for (let index = 0; index < count; index++) {
            let tmpFun = function(cb){
                self.view.playRecycleDispatchCards(index, true, const_recycle_duration, const_recycle_interval, const_recycle_seat_interval * index, cb)  
            }   
            list.push(tmpFun)  
        }
        PromiseUtility.all(list).then(function(){
            cc.warn('22222222222')
        })
    }

    protected testShowDiscards(show?: boolean){
        let self = this
        let discards = [
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_2),
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_3),
            // Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_4),
            Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
        ]
        let discards1 = [
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
        ]

        let count = 5
        for (let index = 0; index < count; index++) {
            self.view.showSeatDispatchCards(index, !!show, false, discards)
            // self.view.showSeatDispatchCards(index, !!show, false, discards1)
        }
    }

    protected testPlayMingPai(show: boolean){
        let self = this        
        let codeList = [
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_2),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_3),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_4),
            Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
        ]
        for (let index = 0; index < 5; index++) {
            if(index == 0){
                self.view.showOpenCardAnim(index, show)
                self.view.mySeatCards.showPokers(false)
            }else{
                self.view.showSeatHandCards(index, false)
            }            
            self.view.showSeatMingHandCards(index, show, codeList, {playAnim: true, pointNum: 3, onFinishPlayAnim: function(){
                if(index == 0){
                    self.view.showKaiPaiLoseAnim(index, show)
                }
            }})         
        }
    }

    protected testPlayCardTypeAnim(show: boolean){
        let self = this
        for (let index = 0; index < 5; index++) {
            self.view.showSanTiaoAnim(index, show, function(){
                self.view.showSiTiaoAnim(index, show, function(){
                    self.view.showShunZiAnim(index, show, function(){
                        self.view.showTongHuaAnim(index, show, function(){
                            self.view.showTongHuaShunAnim(index, show, function(){
                                self.view.showHuangJiaTongHuaShunAnim(index, show, function(){

                                }) 
                            }) 
                        }) 
                    }) 
                }) 
            })            
        }
    }

    protected testPlayGoldFly(){
        let self = this
        let fromPos = 3
        let toPos = 1
        let list = [
            function(cb){
                self.view.playFlyBombAnim(toPos, fromPos, function(){
                    self.m_tableSound.playGunBombEffectSound()
                    self.view.playSeatBombAnim(toPos, 0, cb) 
                })                
            },
            function(cb){
                self.m_tableSound.playAddChipEffectSound()
                self.view.playGoldFlyAnim(fromPos, toPos, const_gold_fly_duration, cb, 20, 0.03)
            },
            function(cb){                
                self.view.showSeatGoldAnim(toPos, true, 0, cb)
            },
            function(cb){
                self.view.showSeatPiaoFen(toPos, true, 999, cb)
            },
        ]
        PromiseUtility.sequence(list)
        
        // self.scheduleOnce(function(){
        //     self.view.showSeatGoldAnim(toPos, true)
        // }, const_gold_fly_duration * 0.8)        
    }    

    protected getAllSameIndexCodeList(codeList: number[], code: number): number[]{
        let list = []
        for (let index = 0; index < codeList.length; index++) {
            const tmpCode = codeList[index];
            if(Card.codeToIndex(tmpCode) == Card.codeToIndex(code)){
                list.push(tmpCode)
            }
        }
        return list
    }

    protected hint_cards(codeList: number[]){
        let self = this
        let list = []
        let maxSum = 0
        let maxCount = 0
        for (let index = CardNameIndex.card_A; index <= CardNameIndex.card_K; index++) {
            let tmpList = self.getAllSameIndexCodeList(codeList, Card.colorIndexToCode(CardColor.color_black_heart, index))
            if(tmpList.length > 0){
                let tmpSum = Card.indexToLogicPoint(index) * tmpList.length
                if(maxSum < tmpSum){
                    maxSum = tmpSum
                    maxCount = tmpList.length
                    list = tmpList
                }else if(maxSum == tmpSum){
                    if(maxCount < tmpList.length){
                        maxCount = tmpList.length
                        list = tmpList
                    }
                }
            }
        }
        if(list.length > 0){
            self.view.mySeatCards.selectPokers(list, null)
            self.view.mySeatCards.refreshPokerSelectState(false)
        }        
    }

    protected testZiMoAnim(){
        let self = this
        self.view.playFeiJiAnim(function(){
            for (let index = 0; index < 5; index++) {
                self.view.showZiMoWenZiAnim(index, true)                
            }
        })
    }

    protected testJiePaoAnim(){
        let self = this
        self.view.showFangPaoAnim(0, true, function(){
            for (let index = 0; index < 5; index++) {
                self.view.showJiePaoWenZiAnim(index, index != 0)                
            }
        })
    }

    protected testFlyBomb(fromPos: number, toPos: number){
        let self = this
        cc.log(fromPos, toPos)
        self.m_tableSound.playRollBombSound()
        self.view.playFlyBombAnim(toPos, fromPos, function(){
            self.m_tableSound.playGunBombEffectSound()
            self.view.playSeatBombAnim(toPos, 0)
        })
    }

    followMultiple = 0
    protected testFollowMultipleChange(){
        let self = this        
        self.view.showFollowMultiple(true, self.followMultiple)
        self.view.playFollowMultipleChangeAnim(function(){
            self.followMultiple++
            self.view.showFollowMultiple(true, self.followMultiple)
        })        
    }

    aIndex = 0
    bIndex = 0

    testQueue = []
    protected testShowHandCards(){
        let self = this
        self.view.setSeatCount(5)
        self.view.resetSeatViewPos()
        ModelData.instance.userToken = 963 + ''
        for (let index = 0; index < 5; index++) {
            self.view.showSeatInfo(index, 963)      
            self.view.showSeatDispatchCards(index, true, false, [1, 2])      
        }
        let ismale = false
        if(this.testQueue.length == 0){            
            this.testQueue = [
                
                // function(){
                //     self.view.showOpenCardBtn(true)
                //     self.view.showMoreCardBtn(true)
                //     self.view.showFollowBtn(true)
                //     self.view.playBtnsFadeAnim(true)
                // },
                // function(){
                //     self.view.playBtnsFadeAnim(false, function(){
                //         self.view.showOpenCardBtn(false)
                //         self.view.showMoreCardBtn(false)
                //         self.view.showFollowBtn(false)
                //     })
                // },

                // function(){
                //     self.testHandCards()
                // },

                // function(){
                //     self.testFaPai()
                // },
                // function(){
                //     let codeList = [
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_5),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_5),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_6),
                //         Card.colorIndexToCode(CardColor.color_red_heart, CardNameIndex.card_6),
                //         Card.colorIndexToCode(CardColor.color_black_heart, CardNameIndex.card_K), 
                //     ]
                //     self.hint_cards(codeList)
                // },
                // function(){
                //     self.testMoPai()
                // },

                
                // function(){
                //     self.testPlayDiscards(CardColor.color_black_heart)
                // },
                // function(){
                //     self.testPlayDiscards(CardColor.color_red_heart)
                // },
                // function(){
                //     self.testPlayDiscardAndRecycle('haaaaa')
                //     self.testPlayDiscardAndRecycle('bbbbbb')
                // },
                // function(){
                //     self.testShowDiscards()                    
                // },
                // function(){
                //     self.testPlayMingPai(true)
                // },
                // function(){
                //     self.testPlayMingPai(false)
                // },

                // function(){
                //     self.testZiMoAnim()
                // },

                // function(){
                //     self.testJiePaoAnim()
                // },

                // function(){
                //     self.testPlayCardTypeAnim(true)
                // },                                
                // function(){
                //     self.testPlayCardTypeAnim(false)
                // },    
                
                // function(){
                //     ModuleManager.instance.showModule(BiPaiGoldOneGameResultModule, {isWin: true, score: 100})
                // },
                // function(){
                //     ModuleManager.instance.destroyModule('BiPaiGoldOneGameResultModule')
                // }

                // function(){
                //     self.testPlayGoldFly()
                // },
                // function(){
                //     self.view.showFangPaoAnim(2, true)
                // },

                // function(){
                //     self.testShowDiscards(true)
                // },
                // function(){
                //     self.testPlayDiscardAndRecycle()
                // },
                // function(){
                //     self.testPlayRecycelAll()
                // },

                // function(){
                //     if(self.bIndex >= 5){
                //         self.bIndex = 0
                //         self.aIndex++
                //     }
                //     if(self.aIndex >= 5){
                //         self.aIndex = 0
                //     }
                //     if(self.aIndex == self.bIndex){
                //         self.bIndex++
                //         if(self.bIndex == 5){
                //             self.aIndex = 0
                //             self.bIndex = 1
                //         }
                //     }
                //     self.testFlyBomb(self.aIndex, self.bIndex)
                //     // self.testFlyBomb(0, 2)
                //     self.bIndex++
                // },

                // function(){
                //     self.m_tableSound.playCardTypeSound(ismale, 1, 1)
                // },
                // function(){
                //     self.m_tableSound.playShunZiSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playTongHuaSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playTongHuaShunSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playHuangJiaTongHuaShunSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playSanTiaoSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playSiTiaoSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playHuLuSound(ismale)
                // },
                // function(){
                //     self.m_tableSound.playFollowSound(ismale, 2)
                // },
                // function(){
                //     self.m_tableSound.playKaiSound(ismale)
                // },
                // function(){
                //     self.testFollowMultipleChange()
                // }
                function(){
                    let data = {
                        dataList: [
                            {point: CardNameIndex.card_2, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_3, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_4, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_5, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_6, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_7, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_8, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_9, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_10, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_J, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_Q, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_K, colorCountList: [1, 1, 1, 1], count: 4},
                            {point: CardNameIndex.card_A, colorCountList: [1, 1, 1, 1], count: 4},

                        ]
                    }
                    self.view.refreshPokerRecorder(data)
                    self.view.showPokerRecorder(true, true)
                }
            ]
        }
        let testFun = this.testQueue.shift()
        testFun()

        
    }
}